module.exports = __webpack_public_path__ + "static/media/mariadb.cc876c0f.svg";